"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DurationFilter = void 0;
const react_1 = __importDefault(require("react"));
const components_1 = require("@veeam/components");
const core_1 = require("@veeam/core");
const core_2 = require("../../../../../../core");
const DurationFilterModel_1 = require("./DurationFilterModel");
require("./types");
const DurationFilter = ({ model }) => {
    const { t } = core_2.useFeatureContext();
    const comboboxModel = core_1.useModelBuilder([
        {
            id: DurationFilterModel_1.TOP_POLICY_WIDGET_SORT.byDurationIncrease,
            name: t('dashboard|topPolicies|header|filter|duration|increase'),
        },
        {
            id: DurationFilterModel_1.TOP_POLICY_WIDGET_SORT.byDurationDecrease,
            name: t('dashboard|topPolicies|header|filter|duration|decrease'),
        },
    ]);
    const form = core_1.useForm(model);
    return (react_1.default.createElement(components_1.ComboboxField, { field: form.fields.sort, model: comboboxModel, widthSize: null, controlRenderer: components_1.createLinkControl() }));
};
exports.DurationFilter = DurationFilter;
//# sourceMappingURL=DurationFilter.js.map